import REAPPRAISAL_RATIONALE_STATUS_TYPE from './reappraisalRationaleStatusTypes';

export const REAPPRAISAL_RATIONALE_REVIEW_DISPLAY_NAMES = new Map([
  [REAPPRAISAL_RATIONALE_STATUS_TYPE.PENDING_REVIEW, 'Pending Review'],
  [REAPPRAISAL_RATIONALE_STATUS_TYPE.APPROVED, 'Approved'],
  [REAPPRAISAL_RATIONALE_STATUS_TYPE.RETURNED, 'Returned']
]);

export const COMMENT_MIN_LENGTH = 25;
export const COMMENT_MAX_LENGTH = 1000;
